import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: {
    width: null,
    infiniteScroll: {
      type: Boolean,
      default: false
    },
    transition: {
      default: ''
    },
    hasNextPage: {
      type: Boolean,
      default: true
    },
    height: {
      default: undefined
    },
    fillType: {
      default: 'dynamic'
    },
    backgroundColor: {
      default: 'var(--v-background-base)'
    }
  },
  setup(__props) {
    return {
      __sfc: true
    };
  }
});